const homepageHeader = ($) => {

	if (window.matchMedia('(max-width: 782px)').matches) {
		$("#js-homepage-header--video").hide();
	}
	else {
		$("#js-homepage-header--video").show();
	}

}

export default homepageHeader